import { Subject } from 'rxjs/Subject';

export class WarningModalActions {
    allowNavigate?: Subject<boolean>;
    keepWorking?(): void;
    discard?(): void;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/unsaved.warning.modal/warning.modal.actions.ts